import type { SimpleMarketplaceResponse } from '@yoop/data-access-model';
import { datetime } from '@yoop/datetime';
import { isNil } from 'ramda';
import { cancelled } from './cancelled';

/**
 * Predicate for active marketplaces
 * @param marketplace
 */
export const active = (marketplace: SimpleMarketplaceResponse): boolean => {
  if (!marketplace) {
    return false;
  }
  const startDate = marketplace.startDateTime
    ? datetime.parse(marketplace.startDateTime)
    : undefined;
  const endDate = marketplace.endDateTime ? datetime.parse(marketplace.endDateTime) : undefined;
  return (
    !cancelled(marketplace) &&
    !isNil(startDate) &&
    !isNil(endDate) &&
    datetime.isLive(startDate, endDate, 'millisecond')
  );
};
